// Seasonal messaging helper - determines current marketing season and generates seasonal messages to encourage user upgrades

export type marketingSeason = 'Winter' | 'Spring' | 'Summer' | 'Back-to-school' | 'Fall' | 'Holiday';

export function isLeapYear(year: number): boolean {
  return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
}

export function getCurrentSeason(): marketingSeason {
  const date = new Date();
  const month = date.getMonth() + 1;
  const day = date.getDate();

  if (month === 1 || (month === 2 && (day <= 28 || (day === 29 && isLeapYear(date.getFullYear()))))) {
    return 'Winter';
  }
  if (month >= 3 && month <= 5) return 'Spring';
  if (month === 6 || month === 7 || (month === 8 && day <= 14)) return 'Summer';
  if ((month === 8 && day >= 15) || (month === 9 && day <= 14)) return 'Back-to-school';
  if ((month === 9 && day >= 15) || month === 10) return 'Fall';
  return 'Holiday';
}

export function getSeasonalMessage(season?: marketingSeason): string {
  const current = season || getCurrentSeason();
  return `${current} sitters are in high demand--upgrade so you don't miss your chance to connect.`;
}

export function getCustomSeasonalMessage(template: string, season?: marketingSeason): string {
  const current = season || getCurrentSeason();
  return template.replace(/{season}/g, current);
}
